import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class LatestArticleService {

    private API_URL= environment.API_URL;

    constructor(
        private http : HttpClient
    ) {}

    getLatestArticle(type: string) {
        const url = `${this.API_URL}/blog-posts?populate=*&filters[category][name][$eq]=${type}&sort=publishedAt:DESC&pagination[limit]=1`;
      
        return this.http.get(url, { headers: {'Authorization': `Bearer ${environment.API_TOKEN}`}});
    }      
}